import React from 'react';
import TitlePointAPITester from './TitlePointAPITester';

function TitlePoint({ onBack }) {
  return <TitlePointAPITester onBack={onBack} />;
}

export default TitlePoint;
